import { Grid, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useReportFeedMutation } from '../../api/apiSlice';
import FormikButton from '../../components/formik/FormikButton';
import FormikInput from '../../components/formik/FormikInput';
import FormikSelect from '../../components/formik/FormikSelect';
import Screen from '../../components/fragments/Screen';
import Form from '../../components/utilities/Form';
import errorSnackbar from '../../utils/errorSnackbar';

const validate = Yup.object().shape({
    reasons: Yup.string().required().label('Reason'),
    message: Yup.string().required().min(9).label('Message'),
});

export default function ReportScreen() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { id } = useParams();

    const [reportFeed, { isLoading }] = useReportFeedMutation();

    const reasonsArray = [
        'False Information',
        'Violence',
        'Unauthorised Sales',
        'Hate Speech',
        'Sexual Content',
        'Suicide or Self Injury',
        'Terrorism',
        'Political',
        'Harassment',
        'Nudity',
    ];

    return (
        <Screen title="Report Feed">
            <Grid item xs={12}>
                <Typography className="fw-bold">
                    Help your church admin understand the problem. What is going
                    on in this post? (Choose from the drop down and write the
                    description)
                </Typography>
                <Form
                    validationSchema={validate}
                    initialValues={{
                        reasons: '',
                        message: '',
                    }}
                    onSubmit={async ({ reasons, message }, { resetForm }) => {
                        const { data, error } = await reportFeed({
                            id,
                            reasons,
                            message,
                        });

                        errorSnackbar(error, enqueueSnackbar);

                        if (data) {
                            enqueueSnackbar('Reported successfully');
                            resetForm();
                            navigate(-1);
                        }
                    }}
                >
                    <FormikSelect
                        name="reasons"
                        label="Reason"
                        placeholder="Reason"
                        data={reasonsArray?.map((reason) => ({
                            label: reason,
                            value: reason,
                        }))}
                    />
                    <FormikInput
                        name="message"
                        placeholder="Message"
                        multiline
                        rows={4}
                    />

                    <div
                        style={{ display: 'flex', justifyContent: 'flex-end' }}
                    >
                        <FormikButton loading={isLoading} variant="contained">
                            Report
                        </FormikButton>
                    </div>
                </Form>
            </Grid>
        </Screen>
    );
}
